'use strict';

module.exports = {
    START_DATE: 'sig_start_date',
    END_DATE: 'sig_end_date',
    ROLE: 'sig_role',
    SERVICE_ID: 'sig_service_id',
    ACCOUNT_ID: 'sig_account_id'
};